import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';

const Insolvent = ({ values }) => (
  <Content>
    {({
      initialQuestionsInsolventLabel,
      initialQuestionsInsolventYes = '',
      initialQuestionsInsolventNo = '',
      bankruptcyText = ''
    }) => (
      <div>
        <Field name="insolvent" subscription={{ touched: true, error: true }}>
          {({ meta: { touched, error }, input }) => (
            <GenericFieldWrapper
              inputId="insolvent"
              title={initialQuestionsInsolventLabel}
              description={bankruptcyText}
            >
              <GenericRadio.InlineSet
                groupName="insolvent-group"
                items={[
                  { id: initialQuestionsInsolventYes, labelText: initialQuestionsInsolventYes },
                  { id: initialQuestionsInsolventNo, labelText: initialQuestionsInsolventNo }
                ]}
                {...input}
                selectedId={values.insolvent}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      </div>
    )}
  </Content>
);

export default Insolvent;
